import React from 'react';
import Container from 'react-bootstrap/Container';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import StepsCard from '@/components/howitworkspage/StepsCard';

const images = ['/svgs/step4a.svg', '/svgs/step1a.svg', '/svgs/step3a.svg', '/svgs/step2a.svg', '/svgs/step5a.svg', '/svgs/step3b.svg'];
function ForBigsSection() {
  return (
    <div className="site-section">
      <Container fluid="md">
        <Row>
          <Col>
            <h3 id="BigSection">For Individuals</h3>
            <br />
          </Col>
        </Row>
        <Row>
          <StepsCard
            image={images[0]}
            stepNumber="01"
            content={(
              <p>
                Fill out the required details on the signup page! Once you submit, you should get a verification email. If you don’t receive this email, contact us at
                {' '}
                <a href="mailto:contact@bigandmini.org">contact@bigandmini.org</a>
                .
              </p>
                          )}
            title="Sign up"
          />
          <StepsCard
            image={images[1]}
            stepNumber="02"
            content={(
              <p>
                Click the verification link in your email and log onto Big & Mini. Next, fill out the profile details so we can find you a match with similar interests, availability, and goals!
              </p>
                          )}
            title="Verify"
          />
          <StepsCard
            image={images[2]}
            stepNumber="03"
            content={(
              <p>
                Check your email for training details. You’ll need to read through and fill out the attached document and quiz to complete the training. When you’re done, we’ll review your application!
              </p>
                          )}
            title="Training"
          />
          <StepsCard
            image={images[3]}
            stepNumber="04"
            content={(
              <p>
                Congratulations! You’ve qualified to get a match! In the upcoming weeks, we’ll send you an email with the details of your match (don’t worry, we never share any information besides your name and interests).
              </p>
                          )}
            title="Get matched"
          />
          <StepsCard
            image={images[4]}
            stepNumber="05"
            content={(
              <p>
                If you can make your match, log onto your dashboard and click confirm! If not, send your match a chat asking to reschedule. Be sure to hit the nudge button!
              </p>
                          )}
            title="Confirm"
          />
          <StepsCard
            image={images[5]}
            stepNumber="06"
            content={(
              <p>
                When the time of your match arrives, log in to your dashboard and click the meeting link to be redirected to the video call platform. Finally, you’ll get to meet your match!
              </p>
                          )}
            subContent={(
              <div>
                <br />
                <a href="signup" className="nice-yellow-button">Sign Up</a>
              </div>
                          )}
            title="Meet"
          />

        </Row>
      </Container>
    </div>
  );
}

export default ForBigsSection;
